import { render, staticRenderFns } from "./saas_channel_config.vue?vue&type=template&id=06ff2bef&scoped=true"
import script from "./saas_channel_config.vue?vue&type=script&lang=js"
export * from "./saas_channel_config.vue?vue&type=script&lang=js"
import style0 from "./saas_channel_config.vue?vue&type=style&index=0&id=06ff2bef&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ff2bef",
  null
  
)

export default component.exports